enum EarningCalculationMethod {
  FIXED_AMOUNT = 'FIXED_AMOUNT',
  MULTIPLIER = 'MULTIPLIER',
  MULTIPLIER_OF_BASE_RATE = 'MULTIPLIER_OF_BASE_RATE'
}

export default EarningCalculationMethod;
